import React from 'react'
import PropTypes from 'prop-types'
import capitalize from 'lodash/capitalize'
import ShowMore from '../../services/ShowMore'
import { t } from '../../core/i18n'

const MoreInfoBlock = props => {
  const { limitLines, moreInfoText, lessInfoText, text } = props
  const textFormated = text
    .split('\n')
    .filter(p => p)
    .map((p, i) => (
      <span className='info-block-paragraph' key={i}>
        {p}
      </span>
    ))
  return (
    <ShowMore
      lines={limitLines}
      more={moreInfoText}
      less={lessInfoText}
      anchorClass='more-link'
    >
      {textFormated}
    </ShowMore>
  )
}

MoreInfoBlock.defaultProps = {
  limitLines: 5,
  moreInfoText: capitalize(t('common:moreInfo')),
  lessInfoText: capitalize(t('common:lessInfo')),
  text: ''
}

MoreInfoBlock.propTypes = {
  limitLines: PropTypes.number.isRequired,
  moreInfoText: PropTypes.string.isRequired,
  lessInfoText: PropTypes.string.isRequired,
  text: PropTypes.string
}

export default MoreInfoBlock



// WEBPACK FOOTER //
// ./src/ui/texts/more-info-block.js